import { DataLayerModel } from "@merchant-webapp/components";

export class TimePeriodChangeDataLayerModel extends DataLayerModel {
  public static readonly EVENT_NAME: string = "TIME_PERIOD_CHANGED";
  public timePeriod: string;
  public constructor(timePeriod: string) {
    super(TimePeriodChangeDataLayerModel.EVENT_NAME);
    this.timePeriod = timePeriod;
  }
}
